import { Tag } from "antd"

import Icon from "../../Icon"

export const SelectTagRender = (props) => {
  const { label, closable, onClose } = props
  const onPreventMouseDown = (event) => {
    event.preventDefault()
    event.stopPropagation()
  }
  return (
    <Tag
      bordered={false}
      color="processing"
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      closeIcon={
        <Icon type={"cross_small"} style={{ fontSize: 20, lineHeight: 1, color: "#1448CB" }} />
      }

      style={{
        fontSize: 14,
        borderRadius: 14,
        padding: "3px 8px",
        margin: "4px 8px 4px 0",
        textWrap: "balance",
        display: "flex",
        alignItems: "center"
      }}
    >
      {label}
    </Tag>
  )
}
